module.exports = __webpack_public_path__ + "files/cc325dfb9f9f3b02d9ae5510fe4f0db6.png";